<template>
    <b-container fluid class="p-3">
        <b-row class="no-gutters mb-4">
            <grid class="w-100" :isAutoHeight="true" :columnDefs="columnDefs" :rowData="accountChoices" :isSearch="false">
            </grid>
        </b-row>
    </b-container>
</template>

<script>

import { mapGetters } from 'vuex';
import Grid from '../generic/grid/grid.vue';
export default {
    name: 'AccountChart',
    components: {
        Grid
    },
    computed: {
        ...mapGetters('quickbooksOld', ['accountMapping', 'accountChoices']),
        columnDefs() {
            return [
                {
                    field: 'account_number',
                    headerName: 'Account Number',
                },
                {
                    field: 'name',
                    headerName: 'Name',
                    cellRenderer: ({ data }) => data.is_subaccount ? `&nbsp;&nbsp;&nbsp;${data.name}` : data.name
                },
                {
                    field: 'acct_type',
                    headerName: 'Account Type'
                }
            ]
        }
    },

};
</script>

<style scoped>
/* Your component styles here */
</style>
